import React from 'react'
import { connect } from 'react-redux'
import AddToTrolleySticky from './AddToTrolleySticky'
import getMaximumQuantity from '../../helpers/getMaximumQuantity'

const AddToTrolleyStickyContainer = props => <AddToTrolleySticky {...props} data-test='att-sticky' />

const mapStateToProps = (state, ownProps) => {
  const { availability = { data: {} }, trolley } = state
  const {
    hasAvailabilityInfo,
    trolleyButtonStickyOptions,
    trolleyButtonStickyTrackingParams,
    trolleyQuantityOptions,
    warrantyPartNumber
  } = ownProps
  const { partNumber } = trolleyButtonStickyOptions
  const { quantityAvailable } = availability.data[partNumber] || {
    quantityAvailable: trolleyQuantityOptions.maximumQuantity || 0
  }
  const partNumbers = warrantyPartNumber ? [[warrantyPartNumber, partNumber]] : []
  const maximumQuantity = availability.errorDetail ? 10 : getMaximumQuantity(hasAvailabilityInfo, quantityAvailable, 10)
  const isEnabled = !availability.requestDone || !!availability.errorDetail || quantityAvailable > 0

  const buttonProps = { ...trolleyButtonStickyOptions, isEnabled }
  const quantityProps = { ...trolleyQuantityOptions, isEnabled, maximumQuantity, partNumbers }

  const quantityCount = trolley?.[partNumber]?.quantity

  const props = {
    buttonProps,
    quantityProps,
    quantityCount,
    trolleyButtonStickyTrackingParams
  }
  return props
}

export default connect(mapStateToProps)(AddToTrolleyStickyContainer)
export { AddToTrolleyStickyContainer, mapStateToProps }
